// extracted by mini-css-extract-plugin
module.exports = {"c6jm2xk":"c6jm2xk","aside":"aside"};